<template>

  <div class="clients">
    <b-card border-variant="white">
      <b-row>
        <b-col cols="8" class="text-left"
          ><h4>{{ $route.meta.title }}</h4></b-col
        >
        <b-col cols="4" class="text-right">
          <b-button @click.prevent="goBack()" variant="primary"
            >Voltar</b-button
          ></b-col
        >
      </b-row>
      <b-card-body>
        <b-form action="#" @submit.prevent="submitOs()">
          <b-form-row>
            <b-col  cols="12" md="6">
              <b-form-group id="name_client" label="Cliente:">
                <div>
                  <multiselect 
                  required
                  v-model="os.client" 
                  id="ajax" 
                  label="name_client" 
                  track-by="name_client" 
                  selectLabel="Selecionar"
                  deselectLabel="Remover"
                  selectedLabel="Selecionado"
                  placeholder="Digite para pesquisar" 
                  open-direction="bottom" 
                  :options="clientsFounds" 
                  :preserve-search="true"
                  :multiple="false" 
                  :searchable="true" 
                  :loading="isLoadingClient" 
                  :internal-search="false" 
                  :clear-on-select="false" 
                  :close-on-select="true" 
                  :show-no-results="true" 
                  :hide-selected="false" 
                  :custom-label="clientNameWithDocument"
                  @search-change="searchClient">
                  
                    <span slot="noOptions">A lista esta vazia.</span> 
                    <span slot="noResult">Oops! Nada foi encontrado. Considere mudar a sua busca.</span>
                  </multiselect>
                </div>
              </b-form-group>
            </b-col>

            <b-col  cols="12" md="6">
              <b-form-group id="user" label="Técnico / Responsável:">
                <div>
                  <multiselect 
                  required
                  v-model="os.user" 
                  id="ajax" 
                  label="first_name" 
                  track-by="id" 
                  selectLabel="Selecionar"
                  deselectLabel="Remover"
                  selectedLabel="Selecionado"
                  placeholder="Digite para pesquisar" 
                  open-direction="bottom" 
                  :options="usersFounds" 
                  :preserve-search="true"
                  :multiple="false" 
                  :searchable="true" 
                  :loading="isLoadingUser" 
                  :internal-search="false" 
                  :clear-on-select="false" 
                  :close-on-select="true" 
                  :show-no-results="true" 
                  :hide-selected="false" 
                  :custom-label="userNameFull"
                  @search-change="searchUser">
                  
                    <span slot="noOptions">A lista esta vazia.</span> 
                    <span slot="noResult">Oops! Nada foi encontrado. Considere mudar a sua busca.</span>
                  </multiselect>
                </div>
              </b-form-group>
            </b-col>

            <b-col  cols="12" md="6">
            
          <b-form-group id="use">
            <div>
              <label class="typo__label">Status:</label>
              <multiselect 
              v-model="os.status" 
              selectLabel="Selecionar"
              deselectLabel="Remover"
              selectedLabel="Selecionado"
              placeholder="Digite para pesquisar" 
              track-by="status" 
              label="status" 
              :options="statusOs" 
              :searchable="false" 
              :allow-empty="false">
                <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.status }}</strong></template>
              </multiselect>
            </div>
              </b-form-group>
            </b-col>

            <b-col>
            <b-form-group id="document_client" label="Data Inicial:">
                <datetime v-model="os.initial_date"></datetime>
            </b-form-group>
            </b-col>
            <b-col>
            <b-form-group id="document_client" label="Data Final:">
                <datetime v-model="os.final_date"></datetime>
            </b-form-group>
            </b-col>
<b-col>
                        <b-form-group id="warranty" label="Garantia:">
                <b-form-input
                  v-model="os.warranty"
                  placeholder="Garantia"
                ></b-form-input>
              </b-form-group>
              </b-col>
          </b-form-row>

          <b-form-row>
            <b-col  cols="6" md="12">
              <b-form-group id="comments" label="Observações:">
              <b-form-textarea
                id="comments"
                v-model="os.comments"
                placeholder="Escreva Algo..."
                rows="6"
                max-rows="12"
              ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col  cols="6" md="6">
              <b-form-group id="product_description" label="Descrição Produto/Serviço:">
              <b-form-textarea
                id="product_description"
                v-model="os.product_description"
                placeholder="Escreva Algo..."
                rows="6"
                max-rows="12"
              ></b-form-textarea>
              </b-form-group>
            </b-col>
             <b-col  cols="6" md="6">
              <b-form-group id="technical_report" label="Observações 
Laudo Técnico:">
              <b-form-textarea
                id="technical_report"
                v-model="os.technical_report"
                placeholder="Escreva Algo..."
                rows="6"
                max-rows="12"
              ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-form-row>
          <hr />
          <div class="text-left">
            <b-button type="submit" variant="success">Confirmar</b-button>
          </div>
        </b-form>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
// import SpinnerComponent from '../../spinnerComponent.vue';
import { cpf, cnpj } from 'cpf-cnpj-validator'
import Datetime from '../../plugins/datetime/Datetime.vue'
// import { Datetime } from 'vue-datetime';
export default {
  name: "clientsEditComponent",
  props: ["data"],
  components: {
    Multiselect,
    datetime: Datetime
    //  SpinnerComponent
  },
  data() {
    return {
      status: null,
      isvalid: null,
      files: [],
      os: null,
      finalDate: null,
      initialDate: null,
      isLoadingUser:false,
      isLoadingClient: false,
      ClientSelected: null,
      UserSelected: null,
      readonly: true,
      ModalDelete: false,
      formClient: false,
      statusOs:{},
      spinner: false,
      clientsFounds: [],
      usersFounds: [],
      items: [
        { age: 40, first_name: "Dickerson", last_name: "Macdonald" },
        { age: 21, first_name: "Larsen", last_name: "Shaw" },
        { age: 89, first_name: "Geneva", last_name: "Wilson" },
        { age: 38, first_name: "Jami", last_name: "Carney" },
      ],
    };
  },

  computed: {
    client() {
      return this.$store.getters.client;
    },

    filesall() {
      return this.$store.getters.files
    },

     getUser(){
     return this.$store.getters.user
 }
  },

  created() {
    this.$store.dispatch("getOsById", this.$route.params.id).then(resp => {
        this.os = resp.data
    }            
    );
    this.$store.dispatch("getFiles");
    this.$store.dispatch("getStatusOs").then(resp => (
    this.statusOs = JSON.parse(JSON.stringify(resp))
    ))
  },


  methods: {


      searchClient(query) {
        this.isLoadingClient = true 
          if(query.length > 3){      
            this.$store.dispatch("getAllClients", query).then(resp => (
            this.clientsFounds = resp,
            this.isLoadingClient = false
            )); 
          }else{
            this.clientsFounds = []
          }
      },

      clientNameWithDocument ({ name_client, document_client }) {
      return `${name_client} — ${document_client}`
      },

      userNameFull ({ first_name, Last_name }) {
      return `${first_name} ${Last_name}`
      },

      searchUser(query) {
         this.isLoadingUser = true  
          if(query.length > 3){       
            this.$store.dispatch("getAllUsers", query).then(resp => (
            this.usersFounds = resp,
            this.isLoadingUser = false
            )); 
          }else{
            this.usersFounds = []
          }
      },




      //função atual


      cpfValidate () {

      if(this.client.document_client.length < 15){
      console.log(this.client.document_client.length)
      this.isvalid = cpf.isValid(this.client.document_client)
      }else{
      console.log(this.client.document_client.length)
      this.isvalid = cnpj.isValid(this.client.document_client)
      }
    },

    goBack() {
      return this.$router.go(-1);
    },

    searchCep (){
  let cep = this.client.cep_client.replace(/[^0-9]/gi, '')
        this.readonly = 'readonly'
        if (cep.length === 8) {
          this.$http.get('https://viacep.com.br/ws/' + cep + '/json/').then(response => {
            if (response.body.erro === true) {
              this.modal = true
              this.client.cep_client = null
              this.client.street_client = null
              this.client.district_client = null
              this.client.state_client = null
              this.client.city_client = null
  
            } else {
              // this.newclient.cep_client = null
              this.client.street_client = response.data.logradouro
              this.client.district_client = response.data.bairro
              this.client.state_client = response.data.uf
              this.client.city_client = response.data.localidade
              // document.getElementById('form-user-numero_' + this.historical.address.id).focus()
              this.readonly = true
            }
          })
        } else {
          this.readonly = false
              // this.newclient.cep_client = null
              this.client.street_client = null
              this.client.district_client = null
              this.client.state_client = null
              this.client.city_client = null
        }
},

    submitOs() {
      this.spinner = true;
      this.$store.dispatch("editOs", this.os).then(
        this.$toast.open('Cliente Editado com sucesso!')
      );
      this.spinner = false;
    },

    openModal(data, action) {
      if (action === "delete") {
        this.ModalDelete = true;
      }
      if (action === "update") {
        this.formClient = true;
      }
      if (action === "add") {
        this.clearRegisters();
        this.formClient = true;
      }
      this.client = data;
    },

    deleteClient(id) {
      this.spinner = true;
      this.$store
        .dispatch("deletClient", {
          id: id,
        })
        .then(
          this.$store.dispatch("getClients"),
          (this.spinner = false),
          (this.ModalDelete = false)
        );
    },

    getResults(page = 1) {
      this.$store.dispatch("getClients", {
        page: page,
      });
    },
  },
};
</script>



<style scoped >

.fade {
  opacity: 1 !important;
  transition: opacity 0.15s linear;
}


.multiselect__tags {
    height: calc(1.5em + 0.75rem + 2px);
    display: block;
      font-weight: 400;
    line-height: 1.5;
    font-size: 1rem;
    padding: 0.375rem 0.75rem;
    border-radius: 0.25rem;
    border: 1px solid #ced4da;
    background: #fff;
    font-size: 14px;
    color: #495057;
}

.form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}


</style>
<!-- <style src="vue-multiselect/dist/vue-multiselect.min.css"></style> -->